import { useVehicleContext } from '~/contexts/VehicleContext';
import formatAndDropDecimal from '~/utilities/formatAndDropDecimal';

type Props = {
  discountedPrice: number;
  showDiscount: boolean;
  showPriceDrop: boolean;
  totalDiscount: number;
};

export default function OriginalPrice({
  discountedPrice,
  showDiscount,
  showPriceDrop,
  totalDiscount
}: Props) {
  const {
    vehicle: { previousPrice = 0 }
  } = useVehicleContext();
  const show = showDiscount || showPriceDrop;

  return show ? (
    <div data-qa="original-price" className="line-through">
      $
      {showPriceDrop
        ? formatAndDropDecimal(previousPrice)
        : formatAndDropDecimal(discountedPrice + totalDiscount)}
    </div>
  ) : null;
}
